import {
    UiStack,
    UiText,
} from '@experiences/ui-common';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { FontVariantToken } from '@uipath/apollo-core';
import React from 'react';
import { useIntl } from 'react-intl';

import type { TimeWindow } from '../../../util/MigrationUtil';

interface MigrationTimeWindowSelectProps {
    value: string;
    onChange: (value: string) => void;
    localizedWindows: TimeWindow[];
    className?: string;
}

export const MigrationTimeWindowSelect: React.FC<MigrationTimeWindowSelectProps> = ({
    value,
    onChange,
    localizedWindows,
    className,
}) => {
    const { formatMessage: translate } = useIntl();

    return (
        <TextField
            select
            label={translate({ id: 'CLIENT_CHOOSE_ANOTHER_WINDOW' })}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            size="small"
            variant="outlined"
            className={className}
            aria-label={translate({ id: 'CLIENT_CHOOSE_ANOTHER_WINDOW' })}>
            {localizedWindows.map(w => (
                <MenuItem
                    key={w.utcValue}
                    value={w.utcValue}>
                    <UiStack direction="column">
                        <UiText variant={FontVariantToken.fontSizeM}>
                            {w.utcLabel}
                        </UiText>
                        <UiText variant={FontVariantToken.fontSizeS}>
                            {w.localLabel}
                        </UiText>
                    </UiStack>
                </MenuItem>
            ))}
        </TextField>
    );
};
